export var SkillCategory;
(function (SkillCategory) {
    SkillCategory["WEB_SEARCH"] = "Web Search";
    SkillCategory["MONDAY"] = "monday";
    SkillCategory["GMAIL"] = "Gmail";
    SkillCategory["OUTLOOK"] = "Outlook";
    SkillCategory["FINANCIAL_DATA"] = "Financial Data";
    SkillCategory["CALENDAR"] = "Calendar";
    SkillCategory["DRIVE"] = "Drive";
    SkillCategory["TIMER"] = "Timer";
    SkillCategory["MEDIA_SEARCH"] = "Media Search";
    SkillCategory["SENTRY"] = "Sentry";
    SkillCategory["SHEETS"] = "Sheets";
    SkillCategory["RAG"] = "RAG";
    SkillCategory["MEMORY"] = "Memory";
    SkillCategory["BASIC_UI"] = "Basic UI";
    SkillCategory["ACTIVATION"] = "Activation";
    SkillCategory["GROUP_CHAT"] = "Group Chat";
    SkillCategory["PLANNING"] = "Planning";
    SkillCategory["SKILL_AWARENESS"] = "Skill Awareness";
    SkillCategory["IMAGE_GENERATION"] = "Image Generation";
    SkillCategory["LINKEDIN"] = "LinkedIn";
    SkillCategory["FACEBOOK"] = "Facebook";
    SkillCategory["INSTAGRAM"] = "Instagram";
    SkillCategory["X"] = "X";
    SkillCategory["OAUTH_CONNECTION"] = "OAuth Connection";
    SkillCategory["APP"] = "App";
})(SkillCategory || (SkillCategory = {}));
export const SKILL_METADATA = {
    [SkillCategory.MEDIA_SEARCH]: {
        name: 'Media Search',
        description: 'Gif, Images, Videos, Music, etc.',
        icon: 'media-search',
        category: 'Media',
    },
    [SkillCategory.CALENDAR]: {
        name: 'Google Calendar',
        description: 'Let your Taka know how to use a calendar',
        icon: 'google-calendar',
        category: 'Google',
    },
    [SkillCategory.GMAIL]: {
        name: 'Google Mail',
        description: 'Let your Taka know how to use email',
        icon: 'gmail',
        category: 'Google',
    },
    [SkillCategory.OUTLOOK]: {
        name: 'Microsoft Outlook',
        description: 'Let your Taka read and manage Outlook email and calendar',
        icon: 'outlook',
        category: 'Microsoft 365',
        featureFlag: 'enable_outlook_skill',
    },
    [SkillCategory.DRIVE]: {
        name: 'Google Drive',
        description: 'Let your Taka know how to use google drive',
        icon: 'google-drive',
        category: 'Google',
    },
    [SkillCategory.SHEETS]: {
        name: 'Google Sheets',
        description: 'Let your Taka know how to use google sheets',
        icon: 'google-sheets',
        category: 'Google',
    },
    [SkillCategory.MONDAY]: {
        name: 'monday.com',
        description: 'manage things masterfully in monday.com',
        icon: 'monday',
        category: 'Productivity',
    },
    [SkillCategory.WEB_SEARCH]: {
        name: 'Web Search',
        description: 'Search the web and scrape content',
        icon: 'DefaultIcon',
        category: 'AI',
    },
    [SkillCategory.IMAGE_GENERATION]: {
        name: 'Image Generation',
        description: 'Generate images from text prompts',
        icon: 'image',
        category: 'AI',
        featureFlag: 'image_generation_skill',
    },
    [SkillCategory.FINANCIAL_DATA]: {
        name: 'Financial Data',
        description: 'Access financial market data and information',
        icon: 'DefaultIcon',
        category: 'Business',
    },
    [SkillCategory.TIMER]: {
        name: 'Scheduled Tasks',
        description: 'Allow TAKA to wake up and perform tasks',
        icon: 'timer',
        category: 'Productivity',
    },
    [SkillCategory.SENTRY]: {
        name: 'Sentry',
        description: 'Error tracking via Sentry MCP',
        icon: 'sentry',
        category: 'Integrations',
    },
    [SkillCategory.RAG]: {
        name: 'Knowledge Base',
        description: 'Search and retrieve information from uploaded documents and knowledge base',
        icon: 'rag',
        category: 'AI',
    },
    [SkillCategory.MEMORY]: {
        name: 'Memory',
        description: 'Store and retrieve information from memory',
        icon: 'brain',
        category: 'AI',
        featureFlag: 'memory',
    },
    [SkillCategory.BASIC_UI]: {
        name: 'Basic UI',
        description: 'Display basic UI elements',
        icon: 'basic-ui',
        category: 'UI',
        featureFlag: 'basic_ui_skill',
    },
    [SkillCategory.ACTIVATION]: {
        name: 'Activation',
        description: 'Agent activation and onboarding tools',
        icon: 'activation',
        category: 'System',
        hidden: true,
    },
    [SkillCategory.GROUP_CHAT]: {
        name: 'Group Chat Management',
        description: 'Let Taka manage group chats',
        icon: 'group-chat',
        category: 'Communication',
        hidden: true,
    },
    [SkillCategory.PLANNING]: {
        name: 'Planning',
        description: 'Internal tools for structuring multi-step workflows',
        icon: 'planning',
        category: 'System',
        hidden: true,
    },
    [SkillCategory.SKILL_AWARENESS]: {
        name: 'Skill Awareness',
        description: 'Tools for agents to know about and manage their skills',
        icon: 'skills',
        category: 'System',
        hidden: true,
    },
    [SkillCategory.LINKEDIN]: {
        name: 'LinkedIn',
        description: 'Access LinkedIn profile, connections, and share content',
        icon: 'linkedin',
        category: 'Social',
        featureFlag: 'enable_linkedin_skill',
    },
    [SkillCategory.FACEBOOK]: {
        name: 'Facebook',
        description: 'Access Facebook business profile and share posts',
        icon: 'facebook',
        category: 'Social',
        featureFlag: 'enable_facebook_skill',
    },
    [SkillCategory.INSTAGRAM]: {
        name: 'Instagram',
        description: 'Post photos and view insights on Instagram Business accounts',
        icon: 'instagram',
        category: 'Social',
        featureFlag: 'enable_instagram_skill',
    },
    [SkillCategory.X]: {
        name: 'X',
        description: 'Post tweets and share content on X (Twitter)',
        icon: 'x',
        category: 'Social',
        featureFlag: 'enable_x_skill',
    },
    [SkillCategory.OAUTH_CONNECTION]: {
        name: 'OAuth Connection',
        description: 'System tool for connecting OAuth providers',
        icon: 'connection',
        category: 'System',
        hidden: true,
    },
    [SkillCategory.APP]: {
        name: 'App',
        description: 'Interactive UI app panel tools',
        icon: 'app',
        category: 'UI',
        hidden: true,
    },
};
export const COMING_SOON_SKILLS = [
    {
        id: 'TaskManagement',
        name: 'Task Management',
        description: 'Lets TAKA remember and manage tasks',
        icon: 'task-management',
        category: 'Productivity',
        isComingSoon: true,
    },
    {
        id: 'DocsGeneration',
        name: 'PDF / DOCS generation',
        description: 'Create a doc for anything you need',
        icon: 'pdf-docs',
        category: 'Productivity',
        isComingSoon: true,
    },
    {
        id: 'SalesforceMCP',
        name: 'Salesforce MCP',
        description: 'Manage things masterfully in salesforce',
        icon: 'salesforce',
        category: 'Business',
        isComingSoon: true,
    },
    {
        id: 'PhoneCalls',
        name: 'Make Phone Calls',
        description: 'Be able to generate voice calls and have voice conversations',
        icon: 'phone-calls',
        category: 'Communication',
        isComingSoon: true,
    },
    {
        id: 'DeepResearch',
        name: 'Deep research',
        description: 'Perform deep AI detailed research on any subject',
        icon: 'deep-research',
        category: 'AI',
        isComingSoon: true,
    },
];
//# sourceMappingURL=skills.const.js.map